export { default as styledTheme } from './styledTheme' 